/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Shopping_Show_CheckedInputs */

const en_shopping_show_checked = /** @type {(inputs: Shopping_Show_CheckedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.count} checked`)
};

const de_shopping_show_checked = /** @type {(inputs: Shopping_Show_CheckedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} abgehakte zeigen`)
};

/**
* | output |
* | --- |
* | "Show {count} checked" |
*
* @param {Shopping_Show_CheckedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_show_checked = /** @type {((inputs: Shopping_Show_CheckedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Show_CheckedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_show_checked(inputs)
	return en_shopping_show_checked(inputs)
});